// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentProps } from 'react';
import { Auth } from 'aws-amplify';
import {
  CreditProduct,
  Currency,
  Domain,
  Expertise,
  Industry,
  Interest,
  Job,
  Language,
  Level,
  Member,
  Place,
  Platform,
  SupportType
} from '../types/Model';
import { getCommon } from '../apis/base';
import MemberContext from './MemberContext';
import { connect } from 'react-redux';
import { RootState } from '../redux/rootReducer';
import { createStructuredSelector } from 'reselect';

import { loadContext, removeContext, saveContext, UpdatableContext } from './utils';

const LOCALSTORAGE_KEY = 'CommonContext';
const LOCALSTORAGE_MEMBER_KEY = 'MemeberContext'

export interface CommonContextType {
  languages: Language[];
  platforms: Platform[];
  domains: Domain[];
  levels: Level[];
  jobs: Job[];
  places: Place[];
  interests: Interest[];
  expertises: Expertise[];
  industries: Industry[];
  currencies: Currency[];
  supportTypes: SupportType[];
  creditProducts: CreditProduct[];
  me?: Member;
  cart?: [];
}

type CommonType = CommonContextType & UpdatableContext;

type CommonTypeKey = keyof (CommonType)

export const defaultValue: CommonContextType = {
  languages: [],
  platforms: [],
  domains: [],
  levels: [],
  interests: [],
  expertises: [],
  jobs: [],
  currencies: [],
  industries: [],
  supportTypes: ['I005', 'I006', 'I007', 'I010'],
  creditProducts: [],
  places: [],
  me: undefined,
  cart: undefined,
};

const CommonContext = React.createContext<CommonType>({
  ...defaultValue,
  update: () => console.log('CommonContext update no update'),
  clear: () => removeContext(LOCALSTORAGE_KEY),
  isLoading: false,
});

interface Props extends ComponentProps<'div'> {
  // Saving
  isDomainSaveFetching: boolean;
  isPlatformSaveFetching: boolean;
  isLevelSaveFetching: boolean;
  isInterestSaveFetching: boolean;
  isExpertiseSaveFetching: boolean;
  isIndustrySaveFetching: boolean;
  isJobSaveFetching: boolean;
  isCreditProductSaveFetching: boolean;
  isPlaceSaveFetching: boolean;

  // Deleting
  isDomainDeleteFetching: boolean;
  isPlatformDeleteFetching: boolean;
  isLevelDeleteFetching: boolean;
  isInterestDeleteFetching: boolean;
  isExpertiseDeleteFetching: boolean;
  isIndustryDeleteFetching: boolean;
  isJobDeleteFetching: boolean;
  isCreditProductDeleteFetching: boolean;
  isPlaceDeleteFetching: boolean;
}

class Provider extends React.Component<Props, CommonType> {
  state!: CommonType;
  static contextType = MemberContext;
  context!: React.ContextType<typeof MemberContext>;

  constructor(props: Props) {
    super(props);

    this.state = {
      ...loadContext(LOCALSTORAGE_KEY, defaultValue),
      update: this.update,
      clear: this.clear
    }
  }

  componentDidMount() {
    this.update();
  }

  update = async () => {
    if (!this.context.isLogin) {
      this.setState(defaultValue, () => saveContext(LOCALSTORAGE_KEY, defaultValue));
    } else {
      const cognitoKey = localStorage.getItem('CognitoKey');
      const idToken = localStorage.getItem(`${cognitoKey}.idToken`)
      const auth = await Auth.currentAuthenticatedUser().catch((error) => console.log(error));
      // only auth > for external user, check idToken and auth > for internal user use Bifrost login(have idToken and login status is true)
      if (auth || (idToken && auth)) {
        this.setState({ isLoading: true });
        await getCommon().then(common => {
          this.setState({ ...common, supportTypes: ['I005', 'I006', 'I007', 'I010'], isLoading: false }, () => saveContext(LOCALSTORAGE_KEY, common));
        }).catch(() => {
          this.setState({ isLoading: false });
          this.setState(defaultValue, () => saveContext(LOCALSTORAGE_KEY, defaultValue));
          this.clear()
        });
      } else {
        this.setState(defaultValue, () => saveContext(LOCALSTORAGE_KEY, defaultValue));
      }
    }
  }

  clear = async () => {
    removeContext(LOCALSTORAGE_KEY);
    removeContext(LOCALSTORAGE_MEMBER_KEY);
    this.setState(defaultValue, () => saveContext(LOCALSTORAGE_KEY, defaultValue));
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<CommonType>) {
    const isSaved = (!this.props.isDomainSaveFetching && prevProps.isDomainSaveFetching) ||
      (!this.props.isPlatformSaveFetching && prevProps.isPlatformSaveFetching) ||
      (!this.props.isLevelSaveFetching && prevProps.isLevelSaveFetching) ||
      (!this.props.isInterestSaveFetching && prevProps.isInterestSaveFetching) ||
      (!this.props.isExpertiseSaveFetching && prevProps.isExpertiseSaveFetching) ||
      (!this.props.isIndustrySaveFetching && prevProps.isIndustrySaveFetching) ||
      (!this.props.isJobSaveFetching && prevProps.isJobSaveFetching) ||
      (!this.props.isCreditProductSaveFetching && prevProps.isCreditProductSaveFetching) ||
      (!this.props.isPlaceSaveFetching && prevProps.isPlaceSaveFetching);

    const isDeleted = (!this.props.isDomainDeleteFetching && prevProps.isDomainDeleteFetching) ||
      (!this.props.isPlatformDeleteFetching && prevProps.isPlatformDeleteFetching) ||
      (!this.props.isLevelDeleteFetching && prevProps.isLevelDeleteFetching) ||
      (!this.props.isInterestDeleteFetching && prevProps.isInterestDeleteFetching) ||
      (!this.props.isExpertiseDeleteFetching && prevProps.isExpertiseDeleteFetching) ||
      (!this.props.isIndustryDeleteFetching && prevProps.isIndustryDeleteFetching) ||
      (!this.props.isJobDeleteFetching && prevProps.isJobDeleteFetching) ||
      (!this.props.isCreditProductDeleteFetching && prevProps.isCreditProductDeleteFetching) ||
      (!this.props.isPlaceDeleteFetching && prevProps.isPlaceDeleteFetching);

    const { isLoading, update, clear, ...stateWithCommon} = prevState;
    const { isLoading: nextIsLoading, update: nextUpdate, clear: nextClear, ...nextStateWithCommon } = this.state

    const isStateChanged = JSON.stringify(stateWithCommon) !== JSON.stringify(nextStateWithCommon);

    if (isSaved || isDeleted || isStateChanged) {
      this.update()
    }
  }

  render() {
    return (
      <CommonContext.Provider value={this.state}>
        {(this.props.children)}
      </CommonContext.Provider>
    )
  }
}

const mapStateToProps = (state: RootState, ownProps: any) => {
  const selector = createStructuredSelector<any, any>({
  });

  return (state: RootState) => ({
    ...selector(state)
  });
};

export const CommonContextProvider = connect(mapStateToProps)(Provider);

export default CommonContext;
